import { KeyValuePair } from '@app/core/models/keyValuePair';

class NullableActives {
  Null = { key: 0, value: 'Maak keuze'};
  No = { key: 1, value: 'Nee' };
  Yes = { key: 2, value: 'Ja' };
}
const nullableActives = new NullableActives();
const keyValuePairs: KeyValuePair[] = [
    nullableActives.Null,
    nullableActives.No,
    nullableActives.Yes
];

export {
    nullableActives,
    keyValuePairs
}
